import cx from "classnames";
import React, { ReactNode } from "react";

import { BasicIconButton } from "@gaming/xds-react-js";
import { ChevronLeft } from "@gaming/xds-react-js-icons";

import { OnboardingPageContainer } from "../../components";
import { SplitPane } from "../../components/SplitPane";
import { PageType } from "../../constants";
import {
  useProgramColorPicker,
  useProgramFillColorPicker,
} from "../../helpers/useProgramColorPicker";
import { useString } from "../../localization/localizationHelpers";
import * as styles from "./FormPreview.module.css";

type FormPreviewContainerProps = Readonly<{
  children: ReactNode;
  pageType: PageType;
}>;

export const FormPreviewContainer = ({ children, pageType }: FormPreviewContainerProps) => {
  const exit = useString("exit");
  const colorStyle = useProgramColorPicker();
  const fillColor = useProgramFillColorPicker();
  return (
    <OnboardingPageContainer className={styles.previewContainer} pageType={pageType}>
      <SplitPane>
        <BasicIconButton
          as="button"
          onClick={() => history.back()}
          icon={ChevronLeft}
          className={cx(styles.backButton, colorStyle)}
          iconClassName={fillColor}
        >
          {exit}
        </BasicIconButton>
        {children}
      </SplitPane>
    </OnboardingPageContainer>
  );
};
